<script>

import moment from "moment-timezone";
import formatters from '@/mixins/formatters.js';
import Show from "./show.vue";

export default {
    name: "UnidentifiedIndex",
    components: { Show },
    data() {
        return {
            data: {
                data: [],
                current_page: 1,
                total: 0,
            },
            filter: {
                // date_to: null,
                // date_from: null,
                date_to: "05-21-2021",
                date_from: "05-21-2021",
                per_page: 50,
                page: 1,
                timezone: moment.tz.guess(),
            },
            facility: window._app_facility,
        }
    },
    methods: {
        async clear_filter() {
            this.filter = {
                date_to: null,
                date_from: null,
                per_page: 50,
                page: 1,
                facility_id: this.facility.id,
                timezone: moment.tz.guess(),
            };

            await this.store_filter();
            await this.list({ ...this.filter, page: 1 });
        },
        async download() {
            // await this.$lionheart.get("facility-booking/list/payments", { params: { ...this.filter, download: 1 }, responseType: "arraybuffer" }).then((success) => {
            //     let data = success.data;
            //     const file = moment().format("YYYYMMDD");
            //     let blob = new Blob([data], { type: "application/xls" });
            //     const downloadUrl = window.URL.createObjectURL(blob);
            //     const link = document.createElement("a");
            //     link.href = downloadUrl;
            //     link.setAttribute("download", `${file}_payments.xlsx`); //any other extension
            //     document.body.appendChild(link);
            //     link.click();
            //     link.remove();
            // });
            return true
        },
        async paginate(page) {
            // await this.list({ ...this.filter, page: page });
        },


        async view(payment_id, facility_id) {
            // let data = await this.$lionheart.get('facility-booking/list/payments/' + payment_id, { params: { facility_id: facility_id, timezone: moment.tz.guess() } }).then((success) => success.data.data);
            // this.$data.facility_booking = data

            this.$bvModal.show('show-modal')
        },
        async handle_custom_date() {
            // this.filter.date_from = this.custom_filter.date_from;
            // this.filter.date_to = this.custom_filter.date_to;
            // this.$bvModal.hide("date-filter-modal");
            // this.custom_filter.selected_date_option_key = this.custom_filter.is_custom_selected_date_option_key;
            // this.config.is_date_option_selected = true;
            // await this.store_filter();
            // await this.list({ ...this.filter, page: 1 });
        },
    },
    mixins: [formatters],
}
</script>
<template>
   <div>

      <!-- table -->
      <div class="row pl-3 my-3">
         <div class="col-lg-12 mb-4">{{ $t("account-page-visitor.timezone") }} ({{ facility.timezone ?
               facility.timezone.value : "Asia/Tokyo" }})</div>
         <div class="col-12">
               <div class="table-responsive table-bordered visitors-table">
                  <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
                     <thead>
                           <tr>
                              <th>{{ $t("account-page-visitor-payments.amount") }} JPY</th>
                              <th>{{ $t("account-page-visitor-payments.checkin_date") }}</th>
                              <th>{{ $t("account-page-visitor-payments.checkout_date") }}</th>
                              <th>{{ $t("account-page-visitor-payments.settlement_date") }}</th>
                              <th>{{ $t("account-page-visitor-payments.reservation") }}</th>
                              <th>{{ $t("account-page-visitor-payments.booking_status") }}</th>
                              <th>{{ $t("account-page-visitor-payments.payment_status") }}</th>
                              <th>{{ $t("account-page-visitor-payments.captured_date") }}</th>
                              <th>{{ $t("account-page-visitor-payments.detail") }}</th>
                           </tr>
                     </thead>

                     <tbody>
                           <tr v-for="(value, key) in data.data">
                              <td>{{ formatAmount(value.charge.amount) }}</td>
                              <td> -- </td>
                              <td>{{ formatDate(value.checkin_date) ?? "--" }}</td>
                              <td>{{ formatDate(value.checkout_date) ?? "--" }}</td>
                              <td>{{ formatDate(value.payment_metadata.date) }}</td>
                              <td>{{ value.pms_reservation_no ?? "--" }}</td>
                              <td>{{ value.booking_status.code ?? "--" }}</td>
                              <td>{{ value.payment_status.code }}</td>
                              <td>{{ value.captured_created_at ? formatDate(value.captured_created_at) : "--" }}</td>
                              <td> -- </td>
                              <td>
                                 <a class="text-primary cursor-pointer btn" href="javascript:void(0)" role="button"
                                       @click="$refs.show.view(value.payment_transaction_id, facility.id)">{{
                                          $t("account-page-visitor-payments.view") }}</a>
                              </td>
                           </tr>
                     </tbody>
                  </table>
               </div>
         </div>
      </div>

      <div class="row pl-3 my-3">
         <div class="col-8">
               <div class="float-left">
                  <!--                    v-model="visitor_paginate.page"-->
                  <pagination v-model="data.current_page" :options="{ theme: 'bootstrap4', texts: { count: '' } }"
                     :per-page="filter.per_page" :records="data.total" s @paginate="paginate" />
               </div>
         </div>
         <div class="col-lg-4">
               <div class="form-row">
                  <div class="col-8">
                     <label class="float-right">
                           <span class="align-middle">
                              {{ $t("account-page-visitor-payments.show") }}
                           </span>
                     </label>
                  </div>
                  <div class="col-4">
                     <select v-model="filter.per_page" class="form-control" required @change="search()">
                           <option :value="10">10</option>
                           <option :value="25">25</option>
                           <option :value="50">50</option>
                           <option :value="100">100</option>
                           <option :value="250">250</option>
                           <option :value="500">500</option>
                     </select>
                  </div>
               </div>
         </div>
      </div>
      <show ref="show" />
   </div>
</template>

